module.exports = __webpack_public_path__ + "static/media/mandala.fb23ef0b.JPG";